import BackTop from './BackTop';

export default BackTop;
